var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 73,
    viewBox: "0 0 74 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.847412,
    y: 0.467072,
    width: 72.5033,
    height: 72.5033,
    rx: 10.3576,
    fill: "#43CC74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0995 43.1901C37.8148 43.1901 38.3947 42.6104 38.3947 41.8954C38.3947 41.1803 37.8148 40.6007 37.0995 40.6007C36.3843 40.6007 35.8044 41.1803 35.8044 41.8954C35.8044 42.6104 36.3843 43.1901 37.0995 43.1901Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8044 39.3081H38.3938V38.0134C38.3938 38.0166 38.3999 38.0098 38.4138 37.9945C38.4478 37.9571 38.5283 37.8684 38.6793 37.7486C38.809 37.6457 38.8492 37.6191 39.1769 37.4113C40.2919 36.7044 40.9832 35.4752 40.9832 34.1293C40.9832 31.9842 39.2443 30.2452 37.0991 30.2452C34.954 30.2452 33.215 31.9842 33.215 34.1293H35.8044C35.8044 33.4142 36.3841 32.8346 37.0991 32.8346C37.8142 32.8346 38.3938 33.4142 38.3938 34.1293C38.3938 34.579 38.1641 34.9875 37.7904 35.2244C37.3712 35.4901 37.3016 35.5362 37.07 35.72C36.2999 36.3309 35.8044 37.0588 35.8044 38.0134V39.3081Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0991 49.6657C39.3319 49.6657 41.4843 49.0986 43.3907 48.0367L48.874 48.4936L48.4171 43.0103C49.479 41.1039 50.0461 38.9515 50.0461 36.7187C50.0461 29.5682 44.2496 23.7717 37.0991 23.7717C29.9487 23.7717 24.1521 29.5682 24.1521 36.7187C24.1521 43.8691 29.9487 49.6657 37.0991 49.6657ZM42.4268 45.6031L42.7849 45.3878L46.0394 45.659L45.7682 42.4045L45.9835 42.0464C46.9428 40.4506 47.4567 38.6239 47.4567 36.7187C47.4567 30.9983 42.8195 26.3611 37.0991 26.3611C31.3788 26.3611 26.7415 30.9983 26.7415 36.7187C26.7415 42.439 31.3788 47.0763 37.0991 47.0763C39.0043 47.0763 40.831 46.5623 42.4268 45.6031Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocServiceIcon);
export default __webpack_public_path__ + "static/media/SocServiceIcon.e657b93f0ac43bf58252bb0d63c51220.svg";
export { ForwardRef as ReactComponent };